import React, { useState } from "react";

const ServiceHistory = ({ onChange }) => {
  const initialServiceHistory = {
    ServiceDetails: "",
    Amount: "",
    Date: "",
    Type: "",
  };

  const [serviceHistory, setServiceHistory] = useState([initialServiceHistory]);

  const handleChange = (index, name, value) => {
    const updated = [...serviceHistory];
    updated[index][name] = value;
    setServiceHistory(updated);
    onChange(updated);
  };

  const onAddRow = () => {
    const updated = [...serviceHistory, initialServiceHistory];
    setServiceHistory(updated);
  };

  const onDeleteRow = (index) => {
    const updated = serviceHistory.filter((_, i) => i !== index);
    setServiceHistory(updated);
    onChange(updated);
  };

  return (
    <div>
      <table className="min-w-full bg-white rounded-sm border border-[gray-300] text-xs">
        <thead>
          <tr className="bg-[#2663EB] text-white text-sm">
            <th className="px-2 py-1 font-semibold">Sl No</th>
            <th className="px-2 py-1 font-semibold">Service Details</th>
            <th className="px-2 py-1 font-semibold">Amount</th>
            <th className="px-2 py-1 font-semibold">Date</th>
            <th className="px-2 py-1 font-semibold">Type</th>
            <th className="px-2 py-1 font-semibold text-center">Actions</th>
          </tr>
        </thead>

        <tbody>
          {serviceHistory.map((row, index) => (
            <tr key={index}>
              <td className="border">
                <div className="flex gap-2 pl-2">{index + 1}</div>
              </td>

              <td className="border">
                <input
                  type="text"
                  value={row.ServiceDetails || ""}
                  onChange={(e) =>
                    handleChange(index, "ServiceDetails", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>
              <td className="border">
                <input
                  type="text"
                  value={row.Amount || ""}
                  onChange={(e) =>
                    handleChange(index, "Amount", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="date"
                  value={row.Date || ""}
                  onChange={(e) => handleChange(index, "Date", e.target.value)}
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border">
                <input
                  type="text"
                  value={row.Type || ""}
                  onChange={(e) =>
                    handleChange(index, "Type", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                />
              </td>

              <td className="border text-center">
                <button
                  type="button"
                  onClick={onAddRow}
                  className="px-3 py-1.5 mr-2 text-xs font-semibold rounded-xl bg-green-600 hover:bg-green-700 text-white"
                >
                  Add Row
                </button>

                {serviceHistory.length > 1 && (
                  <button
                    type="button"
                    onClick={() => onDeleteRow(index)}
                    className="px-3 py-1.5 text-xs font-semibold rounded-xl bg-red-500 hover:bg-red-600 text-white"
                  >
                    Delete
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ServiceHistory;
